import {
  black,
  gray1,
  hexToRgbaString,
} from 'styles/global_defaults/colors';
import { fetchCourseWaitlist, joinWaitlist, abandonWaitlist } from 'redux/actions/enrollment-waitlist';
import store from '../../redux/store';
import ManageCourseAccessModal from '../../institutions/components/manage-course-access-modal';
import { setCourseAccessModalProps } from '../../redux/actions/course-access-modal';
import SkillViewCourseFlyer from '../components/skill-view-course-flyer';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import t from 'react-translate';

/* @ngInject */
export default function FlyerCtrl(
  _,
  nvCurrentPage,
  $state,
  $scope,
  $stateParams,
  $timeout,
  RailsRoutes,
  UserAuthentication,
  CurrentUserManager,
  CurrentCourseManager,
  CurrentPermissionsManager,
  InstitutionsManager,
  humps,
  PusherManager,
) {
  const vm = this;

  $scope.CurrentUserManager = CurrentUserManager;
  $scope.CurrentCourseManager = CurrentCourseManager;

  $scope.ManageCourseAccessModal = ManageCourseAccessModal;

  vm.$stateParams = $stateParams;
  vm.currentState = $state.current.name;
  vm.CurrentUserManager = CurrentUserManager;
  vm.CurrentCourseManager = CurrentCourseManager;
  vm.CurrentPermissionsManager = CurrentPermissionsManager;
  vm.InstitutionsManager = InstitutionsManager;
  vm.UserAuthentication = UserAuthentication;
  vm.RailsRoutes = RailsRoutes;
  vm.nvCurrentPage = nvCurrentPage;
  $scope.SkillViewCourseFlyer = SkillViewCourseFlyer;

  vm.canEditBasics = CurrentPermissionsManager.isConfigAndRegistrationRole();
  vm.canJoinWaitlist = vm.CurrentUserManager.hasLoggedIn()
    && !!vm.CurrentCourseManager.course?.canTakeCourse
    && !vm.CurrentUserManager.isAdminForCurrentCourse();
  vm.canSeeWaitlistPrompt = !vm.CurrentUserManager.hasLoggedIn() || vm.canJoinWaitlist;

  vm.currentUserCourse = CurrentCourseManager.course.userCourse;

  function initialize() {
    CurrentUserManager.requestAccountEnrollmentsPromise?.then(() => {
      vm.courseBelongsToJourneyThatUserIsEnrolledIn = !!CurrentCourseManager.course.inJourneys.find(
        (journey) => CurrentUserManager.user?.enrollments && !!CurrentUserManager.user?.enrollments?.find(
          (enrollment) => enrollment.course.id === journey.id,
        ),
      );
    });
    if (vm.canJoinWaitlist) {
      store.dispatch(fetchCourseWaitlist({ catalogId: CurrentCourseManager.course.catalogId, userId: CurrentUserManager.user?.id })).then((result) => {
        vm.hasJoinedWaitlist = result.payload?.length > 0;
      });
    } else {
      vm.hasJoinedWaitlist = false;
    }

    PusherManager.initializeCourseChannel(CurrentCourseManager.course.id);
    PusherManager.courseChannel(CurrentCourseManager.course.id)?.bind('enrollment-capacity-changed', enrollmentCapacityChangedHandler);
  }

  function enrollmentCapacityChangedHandler(pusherData) {
    pusherData = humps.camelizeKeys(pusherData);

    if (pusherData.courseId === vm.CurrentCourseManager.course.id) {
      vm.CurrentCourseManager.course.enrollmentLimit = pusherData.enrollmentLimit;
      vm.CurrentCourseManager.course.enrolledStudentsCount = pusherData.enrolledCount;
      vm.CurrentCourseManager.course.numEnrolled = pusherData.enrolledCount;
    }
  }

  initialize();

  vm.courseBelongsToJourneyThatUserIsEnrolledIn = !!CurrentCourseManager.course.inJourneys.find(
    (journey) => CurrentUserManager.user?.enrollments && !!CurrentUserManager.user?.enrollments?.find(
      (enrollment) => enrollment.courseId === journey.id,
    ),
  );

  vm.getParentJourneyNameThatBlocksEnrollment = () => CurrentCourseManager.course.inJourneys.find(
    (journey) => journey.catalogId === CurrentCourseManager.course.blockingJourneyCatalogId,
  )?.name;

  vm.getParentJourneyHomeLinkThatBlocksEnrollment = () => $state.href('learning-journey-home', {
    catalogId: CurrentCourseManager.course.blockingJourneyCatalogId,
  });

  function goToCourseHome() {
    if (CurrentCourseManager.course.isProgram) {
      $state.go('discussions-index', { catalogId: CurrentCourseManager.course.catalogId });
    } else {
      $state.go('course-home', { catalogId: CurrentCourseManager.course.catalogId })
        .then(() => {
        }, () => {
          vm.currentUserCourse = CurrentCourseManager.course.userCourse;
        });
    }
  }

  vm.enroll = () => {
    vm.enrolling = true;

    CurrentCourseManager.enroll($stateParams.referralToken)
      .then(() => {
        if ($stateParams.mobileapp) {
          return webviewDismiss();
        }

        goToCourseHome();
      })
      .catch(webviewDismiss);
  };

  vm.reenroll = () => {
    vm.reEnrolling = true;

    CurrentCourseManager.reenroll()
      .then(() => {
        if ($stateParams.mobileapp) {
          return webviewDismiss();
        }

        goToCourseHome();
      })
      .catch(webviewDismiss);
  };

  vm.joinWaitlist = () => {
    store.dispatch(joinWaitlist(CurrentCourseManager.course.catalogId))
      .then(() => {
        store.dispatch(
          addAlertMessage({
            type: AlertMessageType.SUCCESS,
            header: t.FORM.SUCCESS_BANG(),
            message: t.FLYER.COURSE.ACTION.YOU_ARE_WAITLISTED(),
          }),
        );
        $timeout(() => {
          vm.hasJoinedWaitlist = true;
        });
      });
  };

  vm.abandonWaitlist = () => {
    store.dispatch(abandonWaitlist(CurrentCourseManager.course.catalogId))
      .then(() => {
        store.dispatch(
          addAlertMessage({
            type: AlertMessageType.SUCCESS,
            header: t.FORM.SUCCESS_BANG(),
            message: t.FLYER.COURSE.ACTION.YOU_ARE_REMOVED_FROM_WAITLIST(),
          }),
        );
        $timeout(() => {
          vm.hasJoinedWaitlist = false;
        });
      });
  };

  function webviewDismiss() {
    if ($stateParams.mobileapp) {
      const stateParams = { ...$stateParams };
      stateParams['webview_dismiss'] = true;
      $state.go($state.current.name, stateParams);
    }
  }

  vm.getHeaderStyle = () => {
    const style = {};
    const backgroundImage = vm.CurrentCourseManager.course.flyerCoverPhoto
      ? vm.CurrentCourseManager.course.flyerCoverPhoto
      : vm.CurrentCourseManager.course.headerBackground;

    if (backgroundImage) {
      style.background = `linear-gradient(0deg, ${hexToRgbaString(gray1, 0.5)} 0%, ${hexToRgbaString(gray1, 0)} 100%),
        linear-gradient(${hexToRgbaString(black, 0.1)}, ${hexToRgbaString(black, 0.1)}),
        url("${backgroundImage}")`;
      style['background-position'] = 'bottom, center, center';
      style['background-repeat'] = 'no-repeat, no-repeat, no-repeat';
      style['background-size'] = '100% 50%, cover, cover';
    } else {
      style['background-color'] = vm.CurrentCourseManager.course.headerColor || vm.InstitutionsManager.institution.brandColor;
    }

    return style;
  };

  vm.openManageCourseAccessModal = () => {
    store.dispatch(setCourseAccessModalProps({ catalogId: CurrentCourseManager.course.catalogId }));
  };

  vm.shouldShowSkillAndMetadataView = () => vm.CurrentCourseManager.course?.skillTags?.length > 0 || vm.CurrentCourseManager.course?.courseMetadata?.length > 0;

  $scope.$on('$destroy', () => {
    PusherManager.courseChannel(CurrentCourseManager.course.id)?.unbind('enrollment-capacity-changed', enrollmentCapacityChangedHandler);
  });
}
